<template>
  <div>
    <a-descriptions
      title="订单详细信息"
      bordered
      :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
      layout="vertical"
    >
      <a-descriptions-item label="单据编号">
        {{ data[0].fbillno }}
      </a-descriptions-item>
      <a-descriptions-item label="客户代码">
        {{ data[0].fcusno }}
      </a-descriptions-item>
      <a-descriptions-item label="客户名称">
        {{ data[0].fcusname }}
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions
      bordered
      :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
      layout="vertical"
    >
      <a-descriptions-item label="订单详情">
        <div v-for="(detail,index) in data" :key="index">

          <!--                    产品代码:{{ detail.fnumber }}&nbsp;&nbsp;&nbsp;&nbsp;-->
          <!--                    产品名称:{{ detail.fname }}&nbsp;&nbsp;&nbsp;&nbsp;-->
          <!--                    剩余销售数量:{{ detail.fremaindeliqty }}&nbsp;&nbsp;&nbsp;&nbsp;-->
          <!--                    交货日期:{{ detail.fdeliverydate }}<br/>-->

          <a-card>
            <p>产品代码:{{ detail.fnumber }}</p>
            <p>产品名称:{{ detail.fname }}</p>
            <p>剩余销售数量:{{ detail.fremaindeliqty }}</p>
            <p>交货日期:{{ detail.fdeliverydate.split("T").join(" ") }}</p>
          </a-card>

        </div>
      </a-descriptions-item>
    </a-descriptions>
    <br/>
    <a-button type="primary" @click="pass()">
      审核通过
    </a-button>&nbsp;&nbsp;&nbsp;&nbsp;
    <a-button type="danger" @click="reject()">
      驳回
    </a-button>
  </div>

</template>

<script>
import axios from "axios";

export default {
  name: "examineDetail",
  data() {
    return {
      data: [],
    }
  },
  mounted() {
    axios.get("http://www.tcnanhua.com:5555/t-sal-order/selectTSalOrderByFbillno?fbillno=" + this.$route.query.fbillno + "&fcheckername=" + this.$route.query.fcheckername)
      .then((res) => {
        this.data = res.data.data;
      });
  },
  methods: {
    pass() {
      axios.get("http://www.tcnanhua.com:5555/t-sal-order/pass?fbillno=" + this.$route.query.fbillno + "&fcheckername=" + this.$route.query.fcheckername)
        .then((res) => {
          this.data = res.data.data;
        });
      history.go(-1)
    },
    reject() {
      axios.get("http://www.tcnanhua.com:5555/t-sal-order/reject?fbillno=" + this.$route.query.fbillno + "&fcheckername=" + this.$route.query.fcheckername)
        .then((res) => {
          this.data = res.data.data;
        });
      history.go(-1)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ExamineDetail.vue